import {ICartPromotion} from "@connox/typescript-library/types/cart/CartPromotion";
import window from "../components/lib/WindowExtended";

interface IAddItem {
  itemId: number;
  quantity: number;
}

class UrlSearchParamsHelper {
  private cartItems: IAddItem[] = [];
  private cartPromotion?: ICartPromotion;
  private cartVoucherCode: string | null = null;
  private readonly searchQuery: string;
  private readonly urlSearchParams: URLSearchParams;

  constructor() {
    this.searchQuery = window.location.search;
    this.urlSearchParams = new URLSearchParams(this.searchQuery);

    this.parseURLSearchParams();
  }

  /**
   * Returns the items parsed from the URLSearchParams
   * (includes the additionalItemIds with quantity 1)
   */
  get itemIds() {
    return this.cartItems;
  }

  /* Returns the promotion parsed from the URLSearchParams */
  get promotions() {
    return this.cartPromotion;
  }

  /* Returns the voucherCode parsed from the URLSearchParams */
  get voucherCode() {
    return this.cartVoucherCode;
  }

  /* Convenience Getter */
  public containsParams() {
    return this.hasItem() || this.hasPromotions() || this.hasVoucher();
  }

  /* Returns whether the URLSearchParams contain additional items */
  public hasAdditionalItems() {
    return this.searchQuery.includes("AdditionalItemIds");
  }

  /* Returns whether the URLSearchParams contain items */
  public hasItem(): boolean {
    return (this.searchQuery.includes("AddItem") && this.searchQuery.includes("ItemId")) || this.hasAdditionalItems();
  }

  /* Returns whether the URLSearchParams contain a promotion */
  public hasPromotions(): boolean {
    return this.urlSearchParams.has("p");
  }

  /* Returns whether the URLSearchParams contain a voucherCode */
  public hasVoucher(): boolean {
    return this.searchQuery.includes("AddVoucher") && this.searchQuery.includes("Code");
  }

  /* Method to parse the URLSearchParams */
  private parseURLSearchParams() {
    if (this.hasPromotions()) {
      const promotionId = this.urlSearchParams.get("p");

      if (promotionId) {
        this.cartPromotion = {id: Number(promotionId), reference: this.urlSearchParams.get("pcr") ?? undefined};
      }
    }

    if (this.hasVoucher()) {
      this.cartVoucherCode = this.urlSearchParams.get("Code");
      this.urlSearchParams.delete("Action");
      this.urlSearchParams.delete("Code");
    }

    if (this.hasItem()) {
      this.cartItems.push({
        itemId: Number(this.urlSearchParams.get("ItemId")),
        quantity: this.urlSearchParams.get("Quantity") !== null ? Number(this.urlSearchParams.get("Quantity")) : 1,
      });

      if (this.hasAdditionalItems()) {
        const additionalItemIds = this.urlSearchParams.get("AdditionalItemIds");

        if (additionalItemIds) {
          additionalItemIds.split(",").map((splittedItemId) => {
            this.cartItems.push({
              itemId: Number(splittedItemId),
              quantity: 1,
            });
          });
        }
      }

      this.urlSearchParams.delete("Action");
      this.urlSearchParams.delete("ItemId");
      this.urlSearchParams.delete("Quantity");
      this.urlSearchParams.delete("AdditionalItemIds");
    }

    const currentPage = window.location.href.split("?")[0];
    const cleanedUpUrlParams = this.urlSearchParams.toString() !== "" ? "?" + this.urlSearchParams.toString() : "";
    history.pushState("", "", currentPage + cleanedUpUrlParams);
  }
}

const paramsHelper = new UrlSearchParamsHelper();

export {paramsHelper as UrlSearchParamsHelper};
